import { Component } from "react";
import {withApollo} from 'react-apollo'
import EE from '../../../api/eventemitter'
import {GAME_UPDATE_JAMOUTPUT, GAME_UPDATE_JAMOUTPUT_LIST}  from '../../../api/graphql-mutation'
import {getUserId} from '../../../utility/function'

let idCounter = 0;

class ViewManager extends Component {
  constructor(props) {
    super(props);
    this.state = { views: [] };
  }

  componentDidMount(){
      this.setState({
        views: this.getView()
      })

      EE.on("Update Output",(data)=>{
          const {field,value,index} = data
          // console.log(data)

          this.setState(prev => ({
              views: prev.views.map(v => 
                  v.id === index ? { ...v, [field]: value } : v
              )
          }),()=>{
              this.props.client.mutate({
                mutation: GAME_UPDATE_JAMOUTPUT_LIST,
                variables: {
                  gid: this.props.gid,
                  uid: getUserId(),
                  output: this.state.views
                }
              })
          });
      })

  }

  getView = () => {
    let uid = getUserId()
    let viewList = this.props.participants.find(p => p.uid === uid)?.jamOutput || []
    return viewList 
  }

  addView = () => {
    idCounter = this.state.views[this.state.views.length - 1] ? this.state.views[this.state.views.length - 1].id + 1 : 0;
    let n = {
        name: "New View",
        filter: [],
        groupBy: "pairing",
        id: idCounter
    }
    this.setState((prev) => ({
      views: [...prev.views, n],
    }),()=>{
        this.props.client.mutate({
          mutation: GAME_UPDATE_JAMOUTPUT,
          variables: {
            gid: this.props.gid,
            uid: getUserId(),
            output: n
          }
        })
    })

  }

  deleteView = (id) => {
    this.setState((prev) => ({
      views: prev.views.filter((v) => v.id !== id),
    }),()=>{
        this.props.client.mutate({
          mutation: GAME_UPDATE_JAMOUTPUT_LIST,
          variables: {
            gid: this.props.gid,
            uid: getUserId(),
            output: this.state.views
          }
        })
    });
  };

  render(){
    const { views } = this.state;
    // console.log(this.props.participants)

    return (
      <div style={{ padding: "16px", maxWidth: "380px" }}>
        {views.map((view) => (
          <div
            key={view.id}
            style={{
              background: "#fff",
              borderRadius: "16px",
              border: "0.5px solid #e0e0e0",
              padding: "14px 16px",
              marginBottom: "12px",
            }}
            onClick={()=>{EE.emit("Open Output", view)}}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <span style={{ fontWeight: 600, fontSize: "17px" }}>{view.name}</span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  this.deleteView(view.id)
                }}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#aaa",
                  padding: "2px",
                }}
                aria-label="Delete view"
              >
                🗑
              </button>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "6px" }}>
              <span style={{ fontSize: "13px", color: "#aaa" }}>
                {view.filter.length === 0 ? "≡ Any" : `Selected (${view.filter.length})`}
              </span>
              <span style={{ fontSize: "13px", color: "#aaa" }}>≡ {view.groupBy}</span>
            </div>
          </div>
        ))}

        <button
          onClick={this.addView}
          style={{
            background: "#fff",
            borderRadius: "16px",
            border: "0.5px solid #e0e0e0",
            padding: "14px",
            width: "100%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            color: "#aaa",
            fontSize: "16px",
          }}
        >
          <span
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              background: "#f0f0f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "18px",
              color: "#aaa",
            }}
          >
            +
          </span>
          Add View
        </button>
      </div>
    );
  }
}

export default withApollo(ViewManager)